import React from 'react';

import ConfigTablePage from '../../../components/ConfigTablePage';
import FloorForm from '../../../components/FloorForm';
import { listFloors, deleteFloor } from '../../../api';

const COLUMNS = [
  { label: 'Identifier', width: '140px', minWidth: 140, render: (f) => f.getIdentifier() },
  { label: 'Building', width: 'minmax(180px, 1fr)', minWidth: 180, render: (f) => f.getBuilding()?.getName() },
  { label: 'Rooms', width: '100px', minWidth: 100, render: (f) => f.getRooms() == null ? null : String(f.getRooms().length) }
];

export default function Floors() {
  return (
    <ConfigTablePage
      title='Building floors'
      singular='floor'
      columns={COLUMNS}
      load={listFloors}
      idOf={(f) => f.getID()}
      searchText={(f) => [f.getIdentifier(), f.getBuilding()?.getName()].filter(Boolean).join(' ')}
      searchPlaceholder='Search floor or building'
      renderForm={(row, onSaved) => <FloorForm floor={row ?? undefined} onSuccess={onSaved} />}
      dialogWidth={960}
      remove={(row) => deleteFloor(row.getID())}
      deleteTitle={(row) => 'Delete floor ' + row.getIdentifier() + '?'}
      deleteBody='All associated rooms and devices will be deleted.'
      deleted={(row) => 'Floor ' + row.getIdentifier() + ' deleted.'}
    />
  );
}
